import React, {memo, useCallback, /*useCallback,*/ useMemo} from 'react';
import PropTypes from 'prop-types';
import { DatePicker, Form } from 'antd';
import moment from 'moment';

const { RangePicker } = DatePicker;

const AuditorAuditsDateRangeCell = ({value, onChange, startDate}) => {

  const initialValue = useMemo(() => {
    if (!value?.length) return [];
    return [moment(value?.[0]).utc().startOf('day'), moment(value?.[1]).utc().endOf('day')];
  }, [value]);

  const handleOnchange = useCallback((dates) => {
    if (dates?.length) {
      onChange([moment(dates[0]).utc().startOf('day'), moment(dates[1]).utc().endOf('day')]);
    } else {
      onChange([]);
    }
  }, [onChange]);

  return (
    <RangePicker autoFocus={startDate} /*disabledDate={disabledDate}*/ value={initialValue} onChange={handleOnchange} style={{ width: '100%' }} format="DD-MM-YYYY"/>
  );
};

AuditorAuditsDateRangeCell.propTypes = {
  value: PropTypes.array,
  onChange: PropTypes.func,
  startDate: PropTypes.string,
};

AuditorAuditsDateRangeCell.defaultProps = {
  value: [],
};

export default memo(AuditorAuditsDateRangeCell);


// eslint-disable-next-line react/prop-types
export const renderAuditorAuditDateRangeCell = ({formItemProps, form, field}) => {
  const startDate = form.getFieldValue('startDate');

  return (
  // eslint-disable-next-line react/prop-types
    <Form.Item {...formItemProps} required={field?.required}>
      <AuditorAuditsDateRangeCell startDate={startDate} />
    </Form.Item>
  );
};

